var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecreaseQty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.3333H15.6667V11.6667C15.6667 11.4899 15.5964 11.3203 15.4714 11.1953C15.3464 11.0702 15.1768 11 15 11C14.8232 11 14.6536 11.0702 14.5286 11.1953C14.4036 11.3203 14.3333 11.4899 14.3333 11.6667V14.3333H11.6667C11.4899 14.3333 11.3203 14.4036 11.1953 14.5286C11.0702 14.6536 11 14.8232 11 15C11 15.1768 11.0702 15.3464 11.1953 15.4714C11.3203 15.5964 11.4899 15.6667 11.6667 15.6667H14.3333V18.3333C14.3333 18.5101 14.4036 18.6797 14.5286 18.8047C14.6536 18.9298 14.8232 19 15 19C15.1768 19 15.3464 18.9298 15.4714 18.8047C15.5964 18.6797 15.6667 18.5101 15.6667 18.3333V15.6667H18.3333C18.5101 15.6667 18.6797 15.5964 18.8047 15.4714C18.9298 15.3464 19 15.1768 19 15C19 14.8232 18.9298 14.6536 18.8047 14.5286C18.6797 14.4036 18.5101 14.3333 18.3333 14.3333Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseQty);
export default __webpack_public_path__ + "static/media/decreaseQty.6ad1579c386e8118c74890f947c5c5e1.svg";
export { ForwardRef as ReactComponent };